export function fileUpload() {
    document.addEventListener('change', (event) => {
        const input = event.target;
        if (!input.matches('.ginput_container_fileupload input[type="file"]:not([multiple])')) return;

        let button = input.parentElement.querySelector('.file-upload__remove');
        if (!button && input.files.length) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'file-upload__remove gform-theme-no-framework';
            button.textContent = 'Bestand verwijderen';
            button.setAttribute('aria-controls', input.id);
            button.addEventListener('click', () => {
                input.value = '';
                input.dispatchEvent(new Event('change', { bubbles: true }));
                input.focus();
            });
            input.after(button);
        }

        if (button) button.hidden = !input.files.length;
    });

    document.addEventListener('reset', (event) => {
        event.target.querySelectorAll('.file-upload__remove').forEach((button) => {
            button.hidden = true;
        });
    });
}
